module.exports = __webpack_public_path__ + "static/media/play.beb02b44.png";